export default __webpack_public_path__ + "img/1-876c5a84.png";